<template>
    <div v-if="user_role == 'Client' || user_role == 'Client Administrator'">
        <div id="client-dashboard">
            <vx-card>
                <div class="text-center">
                    <h4 class="pb-10">{{ greetings }} {{ user_name }}</h4>
                    <template>
                        <h5 class="text-dark-grey mb-16 text-center">
                            What would you like to do?
                        </h5>
                        <div class="vx-row">
    
                            <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                                <router-link to="/client-dashboard/campaign/Live">
                                    <vx-card class="client-vx-card">
                                        <vs-row vs-w="12" class="">
                                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                                <feather-icon icon="FilmIcon" svgClasses="h-4 w-4" class="mr-3" />
                                                <h5>Live Campaigns</h5>
                                            </vs-col>
    
                                        </vs-row>
                                    </vx-card>
                                </router-link>
                            </div>
    
                            <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                                <router-link to="/client-dashboard/campaign/Completed">
                                    <vx-card class="client-vx-card">
                                        <vs-row vs-w="12" class="">
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                                <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" class="mr-3" />
                                                <h5>Completed Campaigns</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                        </vs-row>
                                    </vx-card>
                                </router-link>
                            </div>
    
                            <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                                <router-link to="/client-dashboard/campaign/Scheduled">
                                    <vx-card class="client-vx-card">
                                        <vs-row vs-w="12" class="">
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                                <feather-icon icon="GitCommitIcon" svgClasses="h-4 w-4" class="mr-3" />
                                                <h5>Scheduled Campaigns</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                        </vs-row>
                                    </vx-card>
                                </router-link>
                            </div>
    
                            <div class="vx-col w-1/3 md:w-1/4 xl:w-1/4">
                                <router-link to="/client-dashboard/campaign/All">
                                    <vx-card class="client-vx-card">
                                        <vs-row vs-w="12" class="">
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                                <feather-icon icon="AlignCenterIcon" svgClasses="h-4 w-4" class="mr-3" />
                                                <h5>All Campaigns</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                                            </vs-col>
                                        </vs-row>
                                    </vx-card>
                                </router-link>
                            </div>
    
                        </div>
    
                    </template>
                </div>
    
            </vx-card>
    
        </div>
    </div>
    <div v-else>
        <div id="dashboard">
            <div class="vx-row">
                <div v-if="user_role == 'Sales Developer'" class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Sales Developer View</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template>
                            <vs-divider class="p-5" />
                            <router-link to="/sales-developer-campaigns/live/view">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Live Campaigns
                                </span>
                            </router-link>
                        </template>
    
                        <template>
                            <vs-divider class="p-5" />
                            <router-link to="/sales-developer-campaigns/historic/view">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Historic Campaigns
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
    
                    </vx-card>
                </div>
    
                <!-- Sales Developer Tag	 -->
                <template v-if="user_role == 'Sales Developer'">
                    <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10">
                        <vx-card>
                            <vs-row vs-w="12">
                                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                    <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                    <h5>Sales Developer Tag</h5>
                                </vs-col>
                                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            </vs-row>
                            <template>
                                <vs-divider class="p-5" />
                                <router-link to="/tag/add">
                                    <span class="ml-10">
                                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                        Add Tag
                                    </span>
                                </router-link>
                            </template>
                            <template>
                                <vs-divider class="p-5" />
                                <router-link to="/tags">
                                    <span class="ml-10">
                                        <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                        Manage Tags
                                    </span>
                                </router-link>
                            </template>
                            <vs-divider class="p-5" />
    
                        </vx-card>
                    </div>
    
                </template>
           
    
                <!-- Roles -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'roles') || abilities.can('read', 'roles')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Roles</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'roles')">
                            <vs-divider class="p-5" />
                            <router-link to="/role/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Role
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'roles')">
                            <vs-divider class="p-5" />
                            <router-link to="/roles">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Role
                                </span>
                            </router-link>
                            <router-link to="roles/role-permission">
                                <vs-divider class="p-5" />
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Role Permission
                                </span>
                            </router-link>
                        </template>
                    </vx-card>
                </div>
                <!-- Elomark User Types	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'user-types') ||
              abilities.can('read', 'user-types')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Elomark User Types</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'user-types')">
                            <vs-divider class="p-5" />
                            <router-link to="/usertype/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add User Type
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'user-types')">
                            <vs-divider class="p-5" />
                            <router-link to="/usertypes">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage User Type
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Elomark Users	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'elomark-users') ||
              abilities.can('read', 'elomark-users')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Elomark Users</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'elomark-users')">
                            <vs-divider class="p-5" />
                            <router-link to="/elomark-user/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Elomark User
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'elomark-users')">
                            <vs-divider class="p-5" />
                            <router-link to="/elomark-users">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Elomark Users
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Accounts	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'accounts') ||
              abilities.can('read', 'accounts')
            ">
                    <vx-card>
                        <vs-row vs-w="12" class="">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="BookIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Accounts</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'accounts')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/accounts/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Account
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('create', 'accounts')">
                            <vs-divider class="p-5" />
                            <router-link to="/accounts">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Accounts
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- Contacts	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'contacts') ||
              abilities.can('create', 'contacts')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Contacts</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
    
                        <!-- <vs-divider class="p-5" />
                <router-link to="/contacts/associatedContacts">
                <span class="ml-10">
                  <feather-icon
                    icon="LinkIcon"
                    svgClasses="h-4 w-4"
                    class="mr-5"
                  />
                  Associated Contacts
                </span>
              </router-link>
              <vs-divider class="p-5" />
                <router-link to="/contacts/unAssocicatedContacts">
                <span class="ml-10">
                  <feather-icon
                    icon="SlidersIcon"
                    svgClasses="h-4 w-4"
                    class="mr-5"
                  />
                  UnAssociated Contacts
                </span>
              </router-link> -->
                        <!-- <template v-if="abilities.can('read', 'contacts')">
                <router-link to="/contacts/import_to_master_db">
                  <span class="ml-10">
                    <feather-icon
                      icon="UploadIcon"
                      svgClasses="h-4 w-4"
                      class="mr-5"
                    />
                    Import Contacts to Master Database (Temporary)
                  </span>
                </router-link>
              </template>
              <vs-divider class="p-5" /> -->
    
                        <template v-if="abilities.can('create', 'contacts')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/contacts/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Contacts
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'contacts')">
                            <vs-divider class="p-5" />
                            <router-link to="/contacts">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Contacts
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
    
                        </template>
                    </vx-card>
                </div>
                <!-- Clients	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'clients') ||
              abilities.can('read', 'clients')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Clients</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'clients')">
                            <vs-divider class="p-5" />
                            <router-link to="/client/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Clients
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'clients')">
                            <vs-divider class="p-5" />
                            <router-link to="/clients">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Clients
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Client Users	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'client-users') ||
              abilities.can('create', 'client-users')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Client Users</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'client-users')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/client-user/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Client User
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('create', 'client-users')">
                            <vs-divider class="p-5" />
                            <router-link to="/client-users">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Client Users
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Client Email	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'client-email') ||
              abilities.can('read', 'client-email')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Clients Email</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'client-email')">
                            <vs-divider class="p-5" />
                            <router-link to="/clients/addEmail">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Client Email
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'client-email')">
                            <vs-divider class="p-5" />
                            <router-link to="/clients/emailList">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Client Email
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- PO Table	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'purchase-order') ||
              abilities.can('read', 'purchase-order')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Purchase Order</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'purchase-order')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns/purchase-order/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Purchase Order
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'purchase-order')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns/purchase-orders">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>Manage Purchase Order</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- Campaigns	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'campaigns') ||
              abilities.can('read', 'campaigns')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Campaigns</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'campaigns')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Campaign
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'campaigns')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span v-if="user_role != 'Sales Developer'">Manage Campaigns</span>
                                    <span v-if="user_role == 'Sales Developer'">View Campaigns</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                 <!-- Core Fields -->
                 <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
                 abilities.can('create', 'master-fields') ||
                 abilities.can('read', 'master-fields')
               ">
                       <vx-card>
                           <vs-row vs-w="12">
                               <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                               <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                   <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                   <h5>Core Fields</h5>
                               </vs-col>
                               <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                           </vs-row>
                           <template v-if="abilities.can('create', 'master-fields')">
                               <vs-divider class="p-5" />
       
                               <router-link to="/fields/core-field/add">
                                   <span class="ml-10">
                                       <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                       Add Core Field
                                   </span>
                               </router-link>
                           </template>
                           <template v-if="abilities.can('read', 'master-fields')">
                               <vs-divider class="p-5" />
                               <router-link to="/fields/core-fields">
                                   <span class="ml-10">
                                       <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                       Manage Core Field
                                   </span>
                               </router-link>
                               <vs-divider class="p-5" />
                           </template>
                       </vx-card>
                   </div>
                <!-- Master Fields -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'master-fields') ||
              abilities.can('read', 'master-fields')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Master Fields</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'master-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/master-field/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Master Field
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'master-fields')">
                            <vs-divider class="p-5" />
                            <router-link to="/fields/master-fields">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Master Field
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Client Fields -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'client-fields') ||
              abilities.can('read', 'client-fields')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Client Fields</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'client-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/client-field/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Client Field
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'client-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/client-fields">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Client Field
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Campaign Fields -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'campaign-fields') ||
              abilities.can('read', 'campaign-fields')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Campaign Fields</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'campaign-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/campaign-field/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Campaign Field
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'campaign-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/campaign-fields">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Campaign Field
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Opportunity Fields -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'opportunity-fields') ||
              abilities.can('read', 'opportunity-fields')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Opportunity Fields</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'opportunity-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/opportunity-field/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Opportunity Field
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'opportunity-fields')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/fields/opportunity-fields">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Opportunity Field
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Field Values	 -->
                <!-- <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'field-values')
            ">
              <vx-card>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                    <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                    <h5>Field Values</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                </vs-row>
                <template v-if="abilities.can('read', 'field-values')">
                  <vs-divider class="p-5" />
    
                  <router-link to="/campaigns/add-field-values">
                    <span class="ml-10">
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                      Add Field Values
                    </span>
                  </router-link>
                  <vs-divider class="p-5" />
                </template>
              </vx-card>
            </div> -->
    
                <!-- Import Accounts/Contacts Directly To Database	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'import-accounts-contacts-directly-to-database')">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Import accounts directly to database</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'import-accounts-contacts-directly-to-database')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/enhance_account_registration_number">
                                <span class="ml-10">
                                    <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import accounts with company registration number
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'import-accounts-contacts-directly-to-database')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/select_columns_enhance_account_machine_learning">
                                <span class="ml-10">
                                    <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import accounts using machine learning
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'import-accounts-contacts-directly-to-database')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/resume_enhance_account_machine_learning">
                                <span class="ml-10">
                                    <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Resume Import accounts
                                </span>
                            </router-link>
                        </template>
                    </vx-card>
                </div>

                  <!-- Select Campaign Fields	-->
                  <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
                  abilities.can('read', 'select-campaign-fields')
                ">
        
                        <vx-card>
                            <vs-row vs-w="12">
                                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                    <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                    <h5>Select Campaign Fields</h5>
                                </vs-col>
                                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            </vs-row>
                            <template v-if="abilities.can('read', 'select-campaign-fields')">
                                <vs-divider class="p-5" />
        
                                <router-link to="/campaigns/add-more-field">
                                    <span class="ml-10">
                                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                        Select Fields For Campaign
                                    </span>
                                </router-link>
                            </template>
                            <!-- <template v-if="abilities.can('read', 'select-campaign-fields')">
                                <vs-divider class="p-5" />
        
                                <router-link to="/campaigns/add-core-field">
                                    <span class="ml-10">
                                        <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                        Select Core Fields For Campaign
                                    </span>
                                </router-link>
                            </template> -->
                            <template v-if="abilities.can('read', 'select-campaign-fields')">
                                <vs-divider class="p-5" />
        
                                <router-link to="/campaigns/list-more-field">
                                    <span class="ml-10">
                                        <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                        Manage Fields For Campaign
                                    </span>
                                </router-link>
                            </template>
                        </vx-card>
                    </div>
    
                <!-- Import Account/Contact To Campaign -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'import-account-contact-to-campaign')">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Import Account/Contacts To Campaign</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'import-account-contact-to-campaign')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/select_column_import_account_to_campaign">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import Accounts
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'import-account-contact-to-campaign')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/select_column_import_contact_to_campaign">
                                <span class="ml-10">
                                    <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import Contacts
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'import-account-contact-to-campaign')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/accounts/matched_account_contact_list">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Accounts/Contacts List For Campaign
                                </span>
                            </router-link>
                        </template>
                    </vx-card>
                </div>
                <!-- Unmatched Accounts/Contacts	-->
                <!-- <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'unmatched-accounts-contacts')">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Unmatched Account/Contacts of Campaign</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'unmatched-accounts-contacts')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/accounts/unmatched_account_list">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Unmatched Accounts
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'unmatched-accounts-contacts')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/contacts/unmatched_contact_list">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Unmatched Contacts
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div> -->
              
                <!-- Populate Sales Developer Data -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'populate-data') ||
              abilities.can('read', 'populate-data')
            ">
    
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Populate Sales Developer Data</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <!-- <template v-if="abilities.can('read', 'populate-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/populate-sd-data">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Populate SD Data At First Time
                                </span>
                            </router-link>
                        </template> -->
                        <template v-if="abilities.can('read', 'populate-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/populate-additional-data">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Populate Data
                                </span>
                            </router-link>
                        </template>
    
                        <template v-if="abilities.can('read', 'populate-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/refresh-sd-data">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Refresh Data
                                </span>
                            </router-link>
                        </template>

                         <template v-if="abilities.can('read', 'populate-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/refresh-rebuild-sd-data">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Refresh Rebuild Data
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
    
                        <!-- <template v-if="abilities.can('read', 'master-step')">
                <router-link to="/campaigns/manage-field-values">
                  <span class="ml-10">
                    <feather-icon
                      icon="PauseIcon"
                      svgClasses="h-4 w-4"
                      class="mr-5"
                    />
                    Manage Field Values
                  </span>
                </router-link>
                <vs-divider class="p-5" />
              </template> -->
                    </vx-card>
                </div>
                <!-- Assign Sales Developer Data	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'assign-data') ||
              abilities.can('read', 'assign-data')
            ">
    
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Assign Sales Developer Data</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'assign-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/assign-account-data-to-sd">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Assign Account Data
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'assign-data')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/assign-contact-data-to-sd">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Assign Contact Data
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                        <!-- <template v-if="abilities.can('read', 'master-step')">
                <router-link to="/campaigns/manage-field-values">
                  <span class="ml-10">
                    <feather-icon
                      icon="PauseIcon"
                      svgClasses="h-4 w-4"
                      class="mr-5"
                    />
                    Manage Field Values
                  </span>
                </router-link>
                <vs-divider class="p-5" />
              </template> -->
                    </vx-card>
                </div>
    
                <!-- Grade Steps	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'grade-steps') ||
              abilities.can('read', 'grade-steps')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Campaign Grade Steps</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'grade-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/grade-step/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Grade Steps
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'grade-steps')">
                            <vs-divider class="p-5" />
                            <router-link to="/grade-steps">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Grade Steps
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
    
                    </vx-card>
                </div>
                <!-- Grade -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'grade') ||
              abilities.can('read', 'grade')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Campaign Grade</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'grade')">
                            <vs-divider class="p-5" />
                            <router-link to="/grade/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Grade
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'grade')">
                            <vs-divider class="p-5" />
                            <router-link to="/grades">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Grade
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
    
                    </vx-card>
                </div>
                <!-- Clone Grade -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'clone-grade') ||
              abilities.can('read', 'clone-grade')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Clone Grade</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'clone-grade')">
                            <vs-divider class="p-5" />
                            <router-link to="/grade/clone">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Clone Grade
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
    
                    </vx-card>
                </div>
    
                <!-- Categorize Grades	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'categorize-grades') ||
              abilities.can('read', 'categorize-grades')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Categorize Grades</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'categorize-grades')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/create_grade_category">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Create Grade Category
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'categorize-grades')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/manage_grade_category">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Grade Category
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
                <!-- Action Type	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'action-type') ||
              abilities.can('read', 'action-type')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Manage Action Type</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'action-type')">
                            <vs-divider class="p-5" />
                            <router-link to="/audit_trial/action_type/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Action Type
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'action-type')">
                            <vs-divider class="p-5" />
                            <router-link to="/audit_trial/action_types">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Action Type
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
    
                    </vx-card>
    
                </div>
                <!-- Outcome	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'outcome') ||
              abilities.can('read', 'outcome')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Manage Outcome</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'outcome')">
                            <vs-divider class="p-5" />
                            <router-link to="/audit_trial/outcome/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Outcome
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'outcome')">
                            <vs-divider class="p-5" />
                            <router-link to="/audit_trial/outcomes">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Outcome
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
    
                </div>
                <!-- Dial Action	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
            abilities.can('read', 'select-action-type') ||
            abilities.can('read', 'select-dial-action')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Audit Trial</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'select-dial-action')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/audit_trial/select_dial_action">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Select Dial Action
                                </span>
                            </router-link>
                        </template>
    
                        <template v-if="abilities.can('read', 'select-action-type')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/audit_trial/action_type_outcome_option">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Select Action Type Outcome Option
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
    
                </div>
                <!-- Master Step	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'master-steps') ||
              abilities.can('read', 'master-steps')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Master Steps</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'master-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/master-step/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Master Step
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'master-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/master-steps">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Master Steps
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Client Step	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'client-steps') ||
              abilities.can('read', 'client-steps')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Client Steps</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'client-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/client-campaign-step/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Client Step
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'client-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/client-campaign-steps">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Client Steps
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
                <!-- Campaign Step	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'campaign-steps')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="MapIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Setup Campaigns Steps</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'campaign-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/choose-campaign-steps">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Campaign Steps
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'campaign-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/manage-campaign-steps">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>Manage Campaign Steps</span>
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'campaign-steps')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/view-gantt-steps">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>View Campaign Steps</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
    
                        </template>
                    </vx-card>
                </div>
                <!-- Cascading Step	-->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'cascading-fields')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Cascading Fields</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'cascading-fields')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns/add-more-fields-for-cascade">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Select Fields For Cascade
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'cascading-fields')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns/list-cascade-fields">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Fields For Cascade
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- Image Upload	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'image-upload')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Image Upload</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'image-upload')">
                            <vs-divider class="p-5" />
                            <router-link to="/image_upload">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Upload
                                </span>
                            </router-link>
                        </template>
    
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
    
                <!-- Docs Template	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'docs-template') ||
              abilities.can('read', 'docs-template')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Docs Template</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'docs-template')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/create_docs_template">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Create Docs Template
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'docs-template')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/manage_docs_template">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Docs Template
                                </span>
                            </router-link>
                        </template>
    
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
                <!-- Email Template	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'email-template') ||
              abilities.can('read', 'email-template')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Email Template</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'email-template')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/create_email_template">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Create Email Template
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'email-template')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/manage_email_template">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Email Template
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
                <!-- Send Opportunity Alert		 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'send-opportunity-alerts')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Opportunity Alerts</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'send-opportunity-alerts')">
                            <vs-divider class="p-5" />
                            <router-link to="/campaign/send_opportunity_alerts">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Send Opportunity Alerts
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
    
                <!-- Submit Hours	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'submit-hours') && user_role != 'Sales Developer'">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Submit Hours</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="
                  abilities.can('read', 'submit-hours') &&
                  user_role != 'Sales Developer'
                ">
                            <vs-divider class="p-5" />
                            <router-link to="/campaigns/viewManagerSubmitHours">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>View Submiited Hours</span>
                                </span>
                            </router-link>
                        </template>
                        <template v-if="
                  abilities.can('read', 'approve-hours') &&
                  user_role != 'Sales Developer'
                ">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaign/approveWorkingHours">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>Approve Working Hours</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- Sales Developer Submit Hours	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'submit-hours') && user_role == 'Sales Developer'">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Submit Hours</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template>
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/submitHours">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>Submit Hours</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                        <template>
                            <router-link to="/campaigns/viewSubmitHours">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    <span>View Submit Hours</span>
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                            <!-- Sales Developer Submit Hours	 -->
                            <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="user_role == 'Sales Developer'">
                                <vx-card>
                                    <vs-row vs-w="12">
                                        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                            <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-3" />
                                            <h5>Campaign View Settings</h5>
                                        </vs-col>
                                        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                                    </vs-row>
                                    <template>
                                        <vs-divider class="p-5" />
                
                                        <router-link to="/campaigns/sd_campaign_view_settings">
                                            <span class="ml-10">
                                                <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                                <span>Settings</span>
                                            </span>
                                        </router-link>
                                        <vs-divider class="p-5" />
                                    </template>
                                </vx-card>
                            </div>
    
                <!-- Quality Control	 -->
                <div v-if="user_role != 'Sales Developer' && (abilities.can('read', 'quality-control'))" class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Quality Control</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'quality-control')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/quality_control/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Review Campaign Results & Data Changes
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                            <router-link to="/quality_control/opportunities/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Review Opportunities
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
    
                        </template>
                    </vx-card>
                </div>


                <div v-if="user_role != 'Sales Developer' && (abilities.can('read', 'account-contact-requests-qa'))" class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>QA for Account and Contact Requests</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'account-contact-requests-qa')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/quality_control/account_contact_requests/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Account/Contact Requests
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                            <!-- <router-link to="/quality_control/contact_requests/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Contact Requests
                                </span>
                            </router-link>
                            <vs-divider class="p-5" /> -->
    
                        </template>
                    </vx-card>
                </div>

                      <div v-if="user_role != 'Sales Developer' && (abilities.can('read', 'populate-account-contact-request'))" class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Populate Account and Contact Requests</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'populate-account-contact-request')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/campaigns/populate-account-contact-request">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Populate Request Data
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                            <!-- <router-link to="/quality_control/contact_requests/campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Contact Requests
                                </span>
                            </router-link>
                            <vs-divider class="p-5" /> -->
    
                        </template>
                    </vx-card>
                </div>
                <!-- Client User View -->
    
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'client-user-set-default')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Client Default View</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'client-user-set-default')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/client-dashboard/select_default_fields">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Select Default Fields
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'client-user-set-default')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/client-dashboard/campaignlists">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Client Default View
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'client-user-set-default')">
                            <vs-divider class="p-5" />
    
                            <router-link to="/client-dashboard/ClientDefaultViewForOpportunities">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                                Client Default View for Opportunities
                                </span>
                            </router-link>
                        </template>
                        <vs-divider class="p-5" />
                    </vx-card>
                </div>
    
                <!-- Elomark Verticals	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
      abilities.can('create', 'vertical') ||
      abilities.can('read', 'vertical')
    ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Verticals</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'vertical')">
                            <vs-divider class="p-5" />
                            <router-link to="/vertical/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Vertical
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'vertical')">
                            <vs-divider class="p-5" />
                            <router-link to="/verticals">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Vertical
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>
    
                <!-- VIEWS	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
      abilities.can('read', 'client-campaign-views') ||
      abilities.can('read', 'sales-developer-campaign-views')
    ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Views</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'client-campaign-views')">
                            <vs-divider class="p-5" />
                            <router-link to="/views/client_view">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Client View
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'sales-developer-campaign-views')">
                            <vs-divider class="p-5" />
                            <router-link to="/views/sd_view">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    SD View
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                        </template>
                    </vx-card>
                </div>


              

                      <!-- Batch Clients -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('create', 'batch_clients') || abilities.can('read', 'batch_clients')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Batch Clients</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'batch_clients')">
                            <vs-divider class="p-5" />
                            <router-link to="/batch_clients/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add Batch Client
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'batch_clients')">
                            <vs-divider class="p-5" />
                            <router-link to="/batch_clients">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage Batch Client
                                </span>
                            </router-link>
                            <vs-divider class="p-5" />
                            
                        </template>
                    </vx-card>
                </div>


               

                  <!-- Internal Dashboard	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
      abilities.can('read', 'manage-internal-dashboard') ||
       abilities.can('delete', 'manage-internal-dashboard') ||
        abilities.can('update', 'manage-internal-dashboard')
    ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Internal Dashboard</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'manage-internal-dashboard')">
                            <vs-divider class="p-5" />
                            <router-link to="/create_internal_dashboard">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Create Dashboard
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'manage-internal-dashboard')">
                            <vs-divider class="p-5" />
                            <router-link to="/manage_internal_dashboard">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Manage Dashboard
                                </span>
                            </router-link>
                        </template>
                                                                                <vs-divider class="p-5" />

                        
                    </vx-card>
                </div>


                  <!-- Internal Dashboard	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
      abilities.can('read', 'view-internal-dashboard')
    ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>View Internal Dashboard</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'view-internal-dashboard')">
                            <vs-divider class="p-5" />
                            <router-link to="/list_view_internal_dashboard">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   View Dashboard
                                </span>
                            </router-link>
                        </template>
                                                        <vs-divider class="p-5" />

                        
                    </vx-card>
                </div>
    <!-- SD STATUS	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
      abilities.can('create', 'sd-status') ||
      abilities.can('read', 'sd-status')
    ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>SD Status</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('create', 'sd-status')">
                            <vs-divider class="p-5" />
                            <router-link to="/sd_status/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add SD Status  
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'sd-status')">
                            <vs-divider class="p-5" />
                            <router-link to="/sd_statuses">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage SD Status
                                </span>
                            </router-link>
                        </template>
                             <template v-if="abilities.can('create', 'sd-sub-status')">
                            <vs-divider class="p-5" />
                            <router-link to="/sd_sub_status/add">
                                <span class="ml-10">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Add SD Sub Status  
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'sd-sub-status')">
                            <vs-divider class="p-5" />
                            <router-link to="/sd_sub_statuses">
                                <span class="ml-10">
                                    <feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Manage SD Sub Status
                                </span>
                            </router-link>
                                                        <vs-divider class="p-5" />

                        </template>
                        
                    </vx-card>
                </div>

                 
    <!-- Calendar	 -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'calendar')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Calendar</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'calendar')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/calendar">
                                <span class="ml-10">
                                    <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    View Calendar
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'calendar')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/calendar/defaultSettings">
                                <span class="ml-10">
                                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Default Settings
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'calendar')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/calendar/scheduleAvailability">
                                <span class="ml-10">
                                    <feather-icon icon="SlidersIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Schedule Availability
                                </span>
                            </router-link>
                        </template>
                        <template v-if="abilities.can('read', 'calendar')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/calendar/usersCalendar">
                                <span class="ml-10">
                                    <feather-icon icon="SlidersIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    View Users Calendar
                                </span>
                            </router-link>
                            <vs-divider class="p-1" />
                        </template>
                    </vx-card>
                </div>
                  
            


                  <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="abilities.can('read', 'data-administration')">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Data Administration</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                        <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/accounts_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Build Accounts
                                     <vs-icon v-if="data_administration_build_accounts_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                </span>
                            </router-link>
                        </template>

                              <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/contacts_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Build Contacts
                                    <vs-icon v-if="data_administration_build_contacts_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                </span>
                            </router-link>
                        </template>


                               <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/build_campaigns_with_accounts_that_have_no_contacts">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Build Contacts for Accounts with Empty Contacts
                                    <vs-icon v-if="data_administration_campaigns_with_accounts_that_have_no_contacts_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>
                        </template>


                               <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/rebuild_accounts_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Rebuild Accounts
                                                                        <vs-icon v-if="data_administration_campaigns_of_accounts_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                </span>
                            </router-link>

                        </template>
                        


                            <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/rebuild_contacts_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Rebuild Contacts
                                                                        <vs-icon v-if="data_administration_campaigns_of_contacts_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                </span>
                            </router-link>

                        </template>

                          <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/grade_3_rebuild_contacts_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Grade 3 Rebuild Contacts
                                                                        <vs-icon v-if="data_administration_campaigns_of_grade_3_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                </span>
                            </router-link>

                        </template>

                        <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/account_request_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Account Request

                                <vs-icon v-if="data_administration_campaigns_of_account_request_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>


                                </span>
                            </router-link>

                        </template>

                         <template v-if="abilities.can('read', 'data-administration')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/contact_request_data_administration_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Contact Request

                                <vs-icon v-if="data_administration_campaigns_of_contact_request_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>


                                </span>
                            </router-link>
                            <vs-divider class="p-1" />

                        </template>

                        

                        
                    </vx-card>
                </div>

                 

                      <!-- Data Team Management -->
                <div class="vx-col w-1/2 md:w-1/2 xl:w-1/3 mb-10" v-if="
              abilities.can('read', 'import-account-data-team-management') || abilities.can('read', 'import-contact-data-team-management') || abilities.can('read', 'data-build-manage-account-allocation') || abilities.can('read', 'data-build-manage-contact-allocation')
            ">
                    <vx-card>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                                <feather-icon icon="FigmaIcon" svgClasses="h-4 w-4" class="mr-3" />
                                <h5>Data Team Management</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
                        </vs-row>
                             <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/select_column_import_account_to_campaign">
                                <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import Accounts
                                </span>
                            </router-link>
                            
                        </template>

                        <template v-if="abilities.can('read', 'import-contact-data-team-management')">
                            <vs-divider class="p-1" />
    
<router-link to="/data_build/select_column_import_contact_to_campaign">
                                    <span class="ml-10">
                                    <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Import Contacts
                                </span>
                            </router-link>
                            
                        </template>

                        

                           <template v-if="abilities.can('read', 'data-build-manage-account-allocation')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/data_build_account_allocation_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                     Account Data Allocation


                                

                                </span>


                                <vs-icon v-if="data_team_management_account_data_allocation_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                <vs-icon v-if="data_team_management_account_data_allocation_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                    
                            </router-link>
                        </template>

                        

                           <template v-if="abilities.can('read', 'data-build-manage-contact-allocation')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/data_build_contact_allocation_campaigns">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                     Contact Data Allocation
                                </span>

                                   <vs-icon v-if="data_team_management_contact_data_allocation_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>

                                <vs-icon v-if="data_team_management_contact_data_allocation_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                            </router-link>
                        </template>



                        <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_with_accounts_that_have_no_contacts">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Campaigns with Accounts that have no Contacts


                                <vs-icon v-if="data_team_campaigns_with_accounts_that_have_no_contacts_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_with_accounts_that_have_no_contacts_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>
                        </template>



                               <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_of_accounts_requiring_rebuild">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Account Requires Rebuild


                                      <vs-icon v-if="data_team_campaigns_of_accounts_requiring_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_of_accounts_requiring_rebuild_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>

                        </template>


                        <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_of_contacts_requiring_rebuild">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Contact Requires Rebuild
                                     <vs-icon v-if="data_team_campaigns_of_contacts_requiring_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_of_contacts_requiring_rebuild_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>

                        </template>

                           <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_of_grade_3_rebuild">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                    Grade 3 Rebuild
                                     <vs-icon v-if="data_team_campaigns_of_grade_3_rebuild_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_of_grade_3_rebuild_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>

                        </template>

                                 <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_of_request_account">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Request Account
                                    <vs-icon v-if="data_team_campaigns_of_account_request_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_of_account_request_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>



                        </template>

                            <template v-if="abilities.can('read', 'import-account-data-team-management')">
                            <vs-divider class="p-1" />
    
                            <router-link to="/data_build/campaigns_of_request_contact">
                                <span class="ml-10">
                                    <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-5" />
                                   Request Contact
                                     <vs-icon v-if="data_team_campaigns_of_contact_request_green" style="color: green; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                <vs-icon v-if="data_team_campaigns_of_contact_request_orange" style="color: orange; float:right; margin-right:10px;"  size="small"  icon="circle"></vs-icon>
                                </span>
                            </router-link>

                                                        <vs-divider class="p-1" />


                        </template>


                       
                    </vx-card>
                </div>


                


                  
    
           

               

    
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import Vue from "vue";
    import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
    import {
        Ability
    } from "@casl/ability";
    import defineAbilitiesFor from "@/config/abilities";
    import axios from 'axios'
    import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
    export default {
        data() {
            return {
                user_id: null,
                user_role: null,
                abilities: new Ability([]),
                greetings: null,
                user_name: null,
                data_team_management_account_data_allocation_green: false,
                data_team_management_account_data_allocation_orange: false,
                data_team_management_contact_data_allocation_green: false,
                data_team_management_contact_data_allocation_orange: false,
                data_team_campaigns_with_accounts_that_have_no_contacts_green: false,
                data_team_campaigns_with_accounts_that_have_no_contacts_orange: false,
                data_team_campaigns_of_accounts_requiring_rebuild_green: false,
                data_team_campaigns_of_accounts_requiring_rebuild_orange: false,
                data_team_campaigns_of_contacts_requiring_rebuild_green: false,
                data_team_campaigns_of_contacts_requiring_rebuild_orange: false,
                data_team_campaigns_of_grade_3_rebuild_green: false,
                data_team_campaigns_of_grade_3_rebuild_orange: false,
                data_team_campaigns_of_account_request_green: false,
                data_team_campaigns_of_account_request_orange: false,
                data_team_campaigns_of_contact_request_green: false,
                data_team_campaigns_of_contact_request_orange: false,

                data_administration_build_accounts_green: false,
                data_administration_build_contacts_green: false,
                data_administration_campaigns_with_accounts_that_have_no_contacts_green: false,
                data_administration_campaigns_of_accounts_rebuild_green: false,
                data_administration_campaigns_of_contacts_rebuild_green: false,
                data_administration_campaigns_of_grade_3_rebuild_green: false,
                data_administration_campaigns_of_account_request_green: false,
                data_administration_campaigns_of_contact_request_green: false
                   

            };
        },
        components: {
            StatisticsCardLine
        },
        methods: {
              getDataTeamManagementWorkStatus() {
                // this.$vs.loading();
                let self = this;
                let data = {
                    user_id: self.user_id
                }
    
                this.$store
                    .dispatch("accountsManagement/getDataTeamManagementWorkStatus", data)
                    .then(response => {
                        let result = response.data
                        if (result) {
                            self.data_team_management_account_data_allocation_green = result.data_team_management_account_data_allocation_green
                            self.data_team_management_account_data_allocation_orange = result.data_team_management_account_data_allocation_orange
                            self.data_team_management_contact_data_allocation_green = result.data_team_management_contact_data_allocation_green
                            self.data_team_management_contact_data_allocation_orange = result.data_team_management_contact_data_allocation_orange
                            self.data_team_campaigns_with_accounts_that_have_no_contacts_green = result.data_team_campaigns_with_accounts_that_have_no_contacts_green
                            self.data_team_campaigns_with_accounts_that_have_no_contacts_orange = result.data_team_campaigns_with_accounts_that_have_no_contacts_orange
                            self.data_team_campaigns_of_accounts_requiring_rebuild_green = result.data_team_campaigns_of_accounts_requiring_rebuild_green
                            self.data_team_campaigns_of_accounts_requiring_rebuild_orange = result.data_team_campaigns_of_accounts_requiring_rebuild_orange
                            self.data_team_campaigns_of_contacts_requiring_rebuild_green = result.data_team_campaigns_of_contacts_requiring_rebuild_green
                            self.data_team_campaigns_of_contacts_requiring_rebuild_orange = result.data_team_campaigns_of_contacts_requiring_rebuild_orange
                            self.data_team_campaigns_of_grade_3_rebuild_green = result.data_team_campaigns_of_grade_3_rebuild_green
                            self.data_team_campaigns_of_grade_3_rebuild_orange = result.data_team_campaigns_of_grade_3_rebuild_orange
                            self.data_team_campaigns_of_account_request_green = result.data_team_campaigns_of_account_request_green
                            self.data_team_campaigns_of_account_request_orange = result.data_team_campaigns_of_account_request_orange
                            self.data_team_campaigns_of_contact_request_green = result.data_team_campaigns_of_contact_request_green
                            self.data_team_campaigns_of_contact_request_orange = result.data_team_campaigns_of_contact_request_orange

                         
    
                        }
                        
                        // console.log("getDataTeamManagementWorkStatus", result)
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
    
            },
              getDataAdministrationWorkStatus() {
                // this.$vs.loading();
                let self = this;
                let data = {
                    user_id: self.user_id
                }
    
                this.$store
                    .dispatch("accountsManagement/getDataAdministrationWorkStatus", data)
                    .then(response => {
                        let result = response.data
                        if (result) {
                          

                            self.data_administration_build_accounts_green = result.data_administration_build_accounts_green
                            self.data_administration_build_contacts_green = result.data_administration_build_contacts_green
                           self.data_administration_campaigns_with_accounts_that_have_no_contacts_green = result.data_administration_campaigns_with_accounts_that_have_no_contacts_green
                           self.data_administration_campaigns_of_accounts_rebuild_green = result.data_administration_campaigns_of_accounts_rebuild_green
                           self.data_administration_campaigns_of_contacts_rebuild_green = result.data_administration_campaigns_of_contacts_rebuild_green
                           self.data_administration_campaigns_of_grade_3_rebuild_green = result.data_administration_campaigns_of_grade_3_rebuild_green
                            self.data_administration_campaigns_of_account_request_green = result.data_administration_campaigns_of_account_request_green
                            self.data_administration_campaigns_of_contact_request_green = result.data_administration_campaigns_of_contact_request_green

    
                        }
                        
                       // console.log("getDataAdministrationWorkStatus", result)
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
    
            },
            getGreetings() {
                let myDate = new Date();
                let hrs = myDate.getHours();
                if (hrs < 12)
                    this.greetings = 'Good Morning';
                else if (hrs >= 12 && hrs <= 17)
                    this.greetings = 'Good Afternoon';
                else if (hrs >= 17 && hrs <= 24)
                    this.greetings = 'Good Evening';
            },
       

    
        },
        mounted() {
            if (this.user_role == 'Client' && this.user_role == 'Client Administrator') {
                this.getGreetings()
            }




           

        },
        created() {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.user_id = userInfo["uid"];
            this.user_role = userInfo["userRole"];
            this.user_name = userInfo["displayName"];
            var self = this;
            defineAbilitiesFor().then(function (data) {
                self.abilities = data;

                if(self.user_role != 'Sales Developer' && self.user_role != 'Client' && self.user_role != 'Client Administrator') {

                 if(self.abilities.can('read', 'import-account-data-team-management') || self.abilities.can('read', 'import-contact-data-team-management') || self.abilities.can('read', 'data-build-manage-account-allocation') || self.abilities.can('read', 'data-build-manage-contact-allocation')){ 
                     self.getDataTeamManagementWorkStatus()
                 }


                  if(self.abilities.can('read', 'data-administration')){ 
                     self.getDataAdministrationWorkStatus()
                  }
                }
            });
    
            if (!moduleAccountsManagement.isRegistered) {
    
            
                this.$store.registerModule(
                    "accountsManagement",
                    moduleAccountsManagement
                );
                moduleAccountsManagement.isRegistered = true;
            }
        }
    };
    </script>
    
    <style scoped>
    a:active,
    a:visited,
    a:hover {
        color: #626262;
        font-weight: 600;
    }
    
    .vx-card {
        min-height: 373px;
    }
    
    .pointer {
        cursor: pointer;
    }
    
    .client-vx-card {
        min-height: auto !important;
        max-height: auto !important;
    }
    </style>
    